import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {nodeAnatomy} from './anatomy';
import {contentGroupedNodeSize} from './config';
import {$childrenPadding, $borderWidth, $borderColor} from './css-vars';

const {definePartsStyle} = createMultiStyleConfigHelpers(nodeAnatomy);

const style = definePartsStyle(() => {
  return {
    container: {
      // TODO: consume from css-vars
      ...contentGroupedNodeSize,
      boxShadow: `md`,
    },
    heading: {
      overflow: `hidden`,
      textOverflow: `ellipsis`,
    },
    body: {
      gap: `24`,
      overflow: `hidden`,
      textOverflow: `ellipsis`,
      whiteSpace: `nowrap`,
    },
    footer: {
      display: `flex`,
    },
    children: {
      width: `full`,
      display: `flex`,
      flexDirection: `column`,
      gap: `8`,
      py: $childrenPadding.reference,
      paddingRight: $childrenPadding.reference,
      fontWeight: `light`,
      '> *:not(:last-child)': {
        borderStyle: `solid`,
        borderBottomWidth: `calc(${$borderWidth.reference} - 1px)`,
        borderColor: $borderColor.reference,
      },
      '> *': {
        maxWidth: `inherit`,
        textOverflow: `ellipsis`,
        overflow: `hidden`,
        lineHeight: `2`,
        paddingBottom: `8`,
      },
    },
  };
});

export default style;
